export default __webpack_public_path__ + "static/media/DwijendraTripathi.d9a9221e.png";